export default __webpack_public_path__ + "static/media/sunrise.fc4bd929.jpg";